import type { CrisisCooldownBody } from "@/utils/serenity-api-client";

/**
 * Thrown by `createSession` / `getSession` when the server returns 423.
 *
 * Carries the resume timestamp and resources block so the caller can render
 * the Pause screen without re-fetching anything. Distinct from a generic
 * Error so chat.tsx can `instanceof`-discriminate instead of string-matching
 * the message.
 */
export class CrisisCooldownError extends Error {
  readonly body: CrisisCooldownBody;

  constructor(body: CrisisCooldownBody) {
    super("Crisis cooldown");
    this.name = "CrisisCooldownError";
    this.body = body;
  }
}
